export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const SET_NOTIFICATION = 'SET_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const SHOW_NETWORK_ERROR = 'SHOW_NETWORK_ERROR';

export const DEFAULT_NOTIFICATION_ID = 'DEFAULT_NOTIFICATION_ID';
export const NETWORK_ERROR_NOTIFICATION_ID = 'NETWORK_ERROR_NOTIFICATION_ID';
export const SIMPLE_STRING_NOTIFICATION_ID = 'SIMPLE_STRING_NOTIFICATION_ID';
export const INTL_MESSAGE_NOTIFICATION_ID = 'INTL_MESSAGE_NOTIFICATION_ID';
